import React, { useEffect, useState } from "react";

import { AdminLayout } from "../shared/layout";

import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { CardBox } from "../shared/CardBox";
import {
  getWaitingPageStatus,
  updateWaitingPageStatus,
} from "@/data/requests/setting-requests";

export function SettingScreen() {
  const [status, setStatus] = useState("inactive");

  useEffect(() => {
    const fetchStatus = async () => {
      const response = await getWaitingPageStatus();
      setStatus(response.data);
    };

    fetchStatus();
  }, []);

  const updateStatus = async (newStatus) => {
    await updateWaitingPageStatus({ status: newStatus });
    setStatus(newStatus);
  };
  const pageSettings = {
    title: "Genel Ayarlar",
    actions: [
      {
        name: "Kaydet",
        color: "blue",
        icon: "add-icon",
        onClick: () => {
          //Save Settings
        },
      },
    ],
  };
  return (
    <div>
      <AdminLayout title={pageSettings.title} actions={pageSettings.actions}>
        <CardBox
          title="Genel Ayarlar"
          description="Site ayarlarınızı güncelleyin"
        >
          <form className="grid gap-6">
            <div className="grid gap-2">
              <Label htmlFor="site-title">Site Başlığı</Label>
              <Input id="site-title" placeholder="Site başlığını girin" />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="site-description">Site Açıklaması</Label>
              <Textarea
                id="site-description"
                placeholder="Site açıklamasını girin"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="site-logo">Site Logosu</Label>
              <div className="flex items-center gap-4">
                <img
                  alt="Site Logosu"
                  className="rounded-md"
                  height={80}
                  src="/placeholder.svg"
                  style={{
                    aspectRatio: "80/80",
                    objectFit: "cover",
                  }}
                  width={80}
                />
                <Button variant="outline">Logo Yükle</Button>
              </div>
            </div>
          </form>
        </CardBox>
        <CardBox
          title="Bekleme Sayfası Ayarları"
          description="Bekleme sayfasını açarsanız, site bakımdayken kullanıcılar bu sayfayı görür"
        >
          <form className="grid gap-6">
            <div className="grid gap-2">
              {status === "active" ? (
                <Button
                  variant="destructive"
                  onClick={() => updateStatus("inactive")}
                >
                  Bekleme Sayfasını Kapat
                </Button>
              ) : (
                <Button onClick={() => updateStatus("active")}>
                  Bekleme Sayfasını Aç
                </Button>
              )}
            </div>
          </form>
        </CardBox>
      </AdminLayout>
    </div>
  );
}
